import styled from 'styled-components';

export const Card = styled.div`
  border: 1px solid #e8e8e8;
  padding: 20px;
`;

export const Img = styled.img`
  display: block;
  margin: 0 auto;
  height: 185px;
  max-width: 80%;
  object-fit: contain;
`;

export const Description = styled.p`
  margin: 20px 0;
  color: #000;
  font-size: 22px;
  line-height: 33px;
  a {
    text-decoration: none;
    color: inherit;
  }
`;

export const Text = styled.p`
  margin: 20px 0;
  color: #4a4a4a;
  font-size: 14px;
  line-height: 24px;
`;
